import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { salesLeadStageOrder, type SalesLeadStatus } from '@/models/salesLead'
import { StatusChip } from './StatusChip'

interface LeadActionStatusPickerProps {
  value: SalesLeadStatus | null
  onChange: (status: SalesLeadStatus) => void
}

/** Picks the status a Change status run moves each lead to. */
export function LeadActionStatusPicker({ value, onChange }: LeadActionStatusPickerProps) {
  return (
    <Select value={value ?? ''} onValueChange={(status) => onChange(status as SalesLeadStatus)}>
      <SelectTrigger className="w-full" aria-label="New status">
        <SelectValue placeholder="Pick the new status" />
      </SelectTrigger>
      <SelectContent>
        {salesLeadStageOrder.map((status) => (
          <SelectItem key={status} value={status}>
            <StatusChip status={status} />
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
